import * as Sentry from "@sentry/react";

/**
 * Initializes Sentry once at app boot.
 *
 * DSN is read from `VITE_SENTRY_DSN` (Vite exposes only `VITE_` prefixed
 * vars to client code). If unset, init is a no-op.
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  const environment =
    (import.meta.env.VITE_SENTRY_ENV as string | undefined) ||
    import.meta.env.MODE;

  Sentry.init({
    dsn,
    environment,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 0,
    replaysOnErrorSampleRate: 1.0,
    replaysSessionSampleRate: 0,
    integrations: [
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
  });
}

export { Sentry };
